import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

if (environment.production) {
  enableProdMode()
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    const el = document.getElementById('app-loading')
    if (el) {
      el.remove()
    }
  })
  .catch(err => console.error(err))
